<script>
/**
* @overview 课后游戏包编辑
*
* @author huojinzhao
*/

import mapUtils, { $form, $http } from "@/utils";

export default {
  name: "GamePackEditor",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    type: {
      type: [String, Number],
      required: true,
    },

    data: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    innerVisible: false,
    options: [],
    value: "",

    formData: null,

    outsource: {
      name: "",
      flag: "",
      url: "",
      game_type: "",
      question_type: "",
      question_number: "",
      option_number: "",
      description: "",
    },
    question_type: [
      {
        label: "选择题",
        value: 1,
      },
      {
        label: "录音题",
        value: 2,
      },
      {
        label: "拼写题",
        value: 3,
      },
      {
        label: "听音看图",
        value: 4,
      },
      {
        label: "判断正误",
        value: 5,
      },
    ],
    question_number: [
      {
        label: "1",
        value: 1,
      },
      {
        label: "2",
        value: 2,
      },
      {
        label: "3",
        value: 3,
      },
      {
        label: "4",
        value: 4,
      },
      {
        label: "5",
        value: 5,
      },
      {
        label: "6",
        value: 6,
      },
      {
        label: "7",
        value: 7,
      },
      {
        label: "8",
        value: 8,
      },
      {
        label: "9",
        value: 9,
      },
      {
        label: "10",
        value: 10,
      },
      {
        label: "不限",
        value: 0,
      },
    ],
    loading: {
      submit: false,
    },

    recorderErrors: [],

    rules: {
      name: [
        $form.rules.required("游戏名称"),
      ],
      flag: [
        $form.rules.required("游戏唯一标识"),
      ],
      game_type: [
        $form.rules.required("所属类型", "number", "change"),
      ],
      question_type: [
        $form.rules.required("题型", "number", "change"),
      ],
      question_number: [
        $form.rules.required("题数", "number", "change"),
      ],
      option_number: [
        $form.rules.required("选项数", "number", "change"),
      ],
      description: [
        $form.rules.required("简介"),
      ],
      image: [
        $form.rules.required("游戏封面"),
      ],
    },
  }),

  computed: {
    isOutsource() {
      // return this.type !== 1;
      return true;
    },

    isCreate() {
      return !this.data;
    },

    gameInit() {
      return this.outsource;
    },
  },

  watch: {
    visible(value) {
      if (value) {
        this.init();
        this.$nextTick(this.clearValidate);
      } else {
        this.formData = null;
      }
    },
  },
  methods: {
    ...mapUtils("form", ["submit", "errorAlert"]),

    init() {
      const data = this.data || this.gameInit;
      this.formData = { type: this.type, ...data };
      $http.get("/game/index_before")
        .then(({ type }) => {
          const typeData = type.filter(item => item.value !== 30);
          const dataList = [];
          typeData.map(item => dataList.push(Object.assign({}, item, { label: item.name })));
          this.options = dataList;
        });
    },

    validate() {
      let result = true;

      this.$refs.form.validate((valid) => {
        result = result && valid;
      });

      result = this.isOutsource
        ? result
        : result && this.recorderValidate();

      result && this.submit();
    },

    submit() {
      this.loading.submit = true;

      const url = "/game_pack";

      this.$form_submit({
        id: this.formData.id,
        uri: url,
        data: this.formData,
      })
        .then(() => {
          this.$emit("success", this.formData.id);
          this.cancel();
        })
        .catch(this.$form_errorAlert)
        .finally(() => {
          this.loading.submit = false;
        });
    },

    cancel() {
      this.$emit("update:visible", false);
    },

    clearValidate() {
      this.$refs.form.clearValidate();

      this.recorderErrors = [];
    },

    recorderValidate() {
      const errorMessage = "游戏资源包含图片、音频、文字，必须补充完整";

      const list = this.formData.config.src;

      let result = true;

      this.recorderErrors = list.map(({
        text,
        image,
        audio,
      }) => {
        const valid = !!(text && image && audio);

        result = result && valid;

        return valid ? "" : errorMessage;
      });

      return result;
    },
  },
};
</script>

<template>
  <el-dialog
    v-if="formData"
    :show-close="false"
    :visible="visible"
    class="game-list-editor"
  >
    <div slot="title">
      {{ isCreate ? '创建游戏' : '编辑游戏' }}
    </div>

    <!-- 游戏公司游戏 -->
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="6em"
    >
      <el-form-item
        label="游戏名称"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          placeholder="请输入游戏名称"
        />
      </el-form-item>
      <el-form-item
        label="唯一标识"
        prop="flag"
      >
        <el-input
          v-model="formData.flag"
          placeholder="请输入游戏唯一标识"
        />
      </el-form-item>
      <el-row class="select_box">
        <el-col :span="12"><el-form-item
          label="所属类型"
          prop="game_type"
        >
          <el-select
            v-model="formData.game_type"
            placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item></el-col>
        <el-col :span="12"><el-form-item
          label="题型"
          prop="question_type"
        >
          <el-select
            v-model="formData.question_type"
            placeholder="请选择">
            <el-option
              v-for="item in question_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item></el-col>
      </el-row>
      <el-row class="select_box">
        <el-col :span="12"><el-form-item
          label="限制题数"
          prop="question_number"
        >
          <el-select
            v-model="formData.question_number"
            placeholder="请选择">
            <el-option
              v-for="item in question_number"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item></el-col>
        <el-col :span="12"><el-form-item
          label="选项数"
          prop="option_number"
        >
          <el-select
            v-model="formData.option_number"
            placeholder="请选择">
            <el-option
              v-for="item in question_number"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            class="textarea"
            label="简介"
            prop="description">
            <el-input
              v-model="formData.description"
              type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
            label="游戏文件"
          >
            <app-qiniu
              v-model="formData.url"
              token-url="/resource/upload_token"
              token-mode="name"
              width="100%"
              height="100%"
              type="rar"
              preview
            >
              <span
                slot="placeholder"
                class="state-primary-icon"
              >
                选择需要上传游戏的压缩包
              </span>
            </app-qiniu>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
            label="游戏封面"
            prop="image"
            class="game_img"
          >
            <FileDialog
              v-model="formData.image"
              width="100%"
              height="100%"
              type="image"
              preview
            >
              <span
                slot="placeholder"
                class="layout-placeholder"
              >
                选择图片
              </span>
            </FileDialog>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>


    <AppFormSubmit
      slot="footer"
      :submitting="loading.submit"
      @submit="validate"
      @cancel="cancel"/>
  </el-dialog>
</template>

<style lang="postcss">
    /* 重置element-ui */

    .game-list-editor .el-form-item__content {
        display: block;
        justify-content: center;
        align-items: center;
        min-height: 40px;
    }

    .game-list-editor .el-input {
        flex-grow: 1;
    }

    .game-list-editor .el-input__inner {
        border-radius: var(--bd-radius);
    }

    /* 组件样式 */

    .game-list-editor__recorder .app-create-label {
        margin-right: 10px;
    }

    .game-list-editor__recorder .iconfont {
        font-size: 20px;
        margin: 0 10px;
    }

    .game-list-editor__recorder:nth-child(2)
    .el-form-item__content > .app-icon {
        visibility: hidden;
    }

    .game-list-editor__recorder-append {
        margin-bottom: 0 !important;
    }

    .game-list-editor__recorder-append .el-form-item__content {
        margin-left: 20px !important;
        display: flex;
        justify-content: center;
    }

    .game-list-editor__control.el-button {
        margin-left: 20px;
    }
    .textarea .el-form-item__content{
        height: 55px !important;
    }
    .select_box .el-select{
      width: 100% !important;
    }
  .game_img .dialog{
    width: 100% !important;
  }
</style>
